<!-- .nav-item from bootstrap and scss/_nav.scss -->
<div class="nav-item">
    <!-- .cmps-nav-icon from bootstrap and scss/_nav.scss -->
    <button
        class="cmps-icon-button--no-bg cmps-icon-button--no-bg--white cmps-nav-icon cmps-teamscall-task-list-nav-button--button"
        [class.active]="_dialogService.isOpen"
        cmpsIconButton
        tabindex="0"
        role="menuitem"
        (click)="_dialogService.toggle()"
    >
        <div
            class="cmps-teamscall-task-list-nav-button--tooltip"
            [cmpsTooltipTrigger]="_i18n._11255_OPEN_TASK_LIST | translate"
            placement="bottom-center"
            [openDelay]="1000"
        ></div>

        <div class="cmps-teamscall-task-list-nav-button--wrapper">
            <cmps-icon
                svgIcon="checkbox-marked-circle-auto-outline"
            ></cmps-icon>
        </div>

        <!-- .line from scss/_nav.scss -->
        <div class="line"></div>
    </button>
</div>
